module.exports = __webpack_public_path__ + "img/banner-index-3.31583bad.jpg";